<template>
    <div>
      <h1>Your Offers</h1>
      <!-- Loop through the user's offers and display the CancelOffer component for each -->
      <CancelOffer v-for="offer in offers" :key="offer.purchaseId" :purchaseId="offer.purchaseId" />

      <CancelConfirmation v-for="offer in offers" :key="offer.purchaseId" :purchaseId="offer.purchaseId" />

      <NoteAndComment v-for="offer in offers" :key="offer.purchaseId" :purchaseId="offer.purchaseId" />
    </div>
  </template>
  
  <script>
  import CancelOffer from '../components/CancelOffer.vue';
  import CancelConfirmation from '../components/CancelConfirmation.vue';
  import NoteAndComment from '../components/NoteAndComment.vue';
  
  export default {
    components: {
      CancelOffer,
      CancelConfirmation,
      NoteAndComment
    },
    data() {
      return {
        offers: [] // This should be fetched from the store or API
      }
    }
  }
  </script>
  